module.exports = __webpack_public_path__ + "static/media/live-tests.b81f74e1.png";